import { SET_USER } from '../types'

const user = {
  user: {
    email: ''
  }
}
export default function ( state = user, action ) {
  if( action.type === SET_USER ) {
    return {
      ...action.payload
    }
  }
  return state
}


// WEBPACK FOOTER //
// ./src/store/reducers/user.js